import { formatRFC3339 } from 'date-fns'

export const currentDate = () => formatRFC3339(new Date())

export function addNullToEnum<M, T extends Record<string, M>>(
  enumObject: T
): [...T[keyof T][], null] {
  return [...Object.values(enumObject), null] as [...T[keyof T][], null]
}
